<template>
	<div>
	
		<div class="qinang-card-2">
			<div class="qa-card-title">
				订单信息
			</div>
			<a-descriptions  size="small">
				<a-descriptions-item label="订单编号">{{orderInfo.ordersNumber}}</a-descriptions-item>
				<a-descriptions-item label="类型">
					<span v-if="orderInfo.ordersType == 2">售票</span>
					<span v-if="orderInfo.ordersType == 3">退票</span>
					<span v-if="orderInfo.ordersType == 4">补录</span>
				</a-descriptions-item>
				<a-descriptions-item label="服务商">{{orderInfo.facilitatorName}}</a-descriptions-item>
				<a-descriptions-item label="售票站点">{{orderInfo.ticketstationName}}</a-descriptions-item>
				<a-descriptions-item label="售票窗口">{{orderInfo.ticketwindowName}}</a-descriptions-item>
				<a-descriptions-item label="售票员">{{orderInfo.staffName}}</a-descriptions-item>
				<a-descriptions-item label="订单数量">{{orderInfo.ordersQuantity}}</a-descriptions-item>
				<a-descriptions-item label="订单总价">{{orderInfo.ordersTotal / 100}}</a-descriptions-item>
				<a-descriptions-item label="下单时间">{{moment(orderInfo.createTime).format('YYYY-MM-DD HH:mm:ss')}}</a-descriptions-item>
			</a-descriptions>
		</div>

		
		<div class="qinang-card">
			<div class="qa-card-title">
				票号信息
				<div class="qa-btn-right" v-if="refundState">
					<a-button type="primary" class="qa-btn"  @click="handleBatchRefund" :disabled="selectedRowKeys.length === 0">批量退款</a-button>
				</div>
			</div>
			<a-table :columns="tableColumns" :data-source="tableData" row-key="orderdetailsId"
				:loading="tableLoading" :pagination="false" :row-selection="rowSelection">
				<span slot="ordersType" slot-scope="ordersType">
					<span v-if="ordersType.ordersType == 2">售票</span>
					<span v-if="ordersType.ordersType == 3">退票</span>
					<span v-if="ordersType.ordersType == 4">补录</span>
				</span>
				<span slot="totalPrice" slot-scope="totalPrice">
					{{totalPrice.totalPrice / 100}}
				</span>
				<span slot="ordersQuantity" slot-scope="ordersQuantity">
					{{ordersQuantity.quantity}}<a-divider type="vertical" />{{ordersQuantity.checkedQuantity}}<a-divider type="vertical" />{{ordersQuantity.refundQuantity}}
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime.createTime)}}
				</span>
				<span slot="operation" slot-scope="operation">
					<a-popover placement="topLeft" v-if="refundState" trigger="click">
						<template slot="content">
							<a-button type="primary" class="qa-btn" size="small" @click="handleRefund(operation)">
								正常退款
							</a-button>
							<a-button type="danger" class="qa-btn" size="small" @click="handleForceRefund(operation)">
								强制退款
							</a-button>
						</template>
						<a-button>退款</a-button>
					</a-popover>
					
				</span>
				
			</a-table>
		</div>
		<a-modal :title="modalTitle" :visible.sync="visible" width="400px" @ok="visible=false" @cancel="visible=false" :maskClosable="false" :keyboard="false">
			<a-form :model="refundForm" :label-col="{span: 5}" :wrapper-col="{span: 14}">
				<a-form-item label="退款类型" prop="type">
					{{ refundForm.type == 1 ? '正常退款': '强制退款' }}
				</a-form-item>
				<a-form-item label="退款数量" prop="refundAmount">
					<a-input-number v-if="refundForm.type == 1" v-model="refundForm.refundAmount" :step="1" :min="0" :max="orderdetails.quantity-orderdetails.refundQuantity"  />
					<a-input-number v-else v-model="refundForm.refundAmount" :step="1" :min="0" :max="orderdetails.checkedQuantity"  />
				</a-form-item>
			</a-form>
			<template slot="footer">
				<a-button type="primary" @click="submitRefund">确认</a-button>
			</template>
		</a-modal>


		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		props:{
			ordersNumber:{
				type:String,
				default:""
			},
			refundState:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				moment,
				// selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				// selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				orderInfo: {},
				orderdetails: {},
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0
				},
				visible: false,
				modalTitle: '订单退款',
				refundForm: {
					orderdetailsId: '',
					type: 2,
					refundAmount: 0
				},
				rules: {
					refundAmount: [
						{ required: true, message: '请输入退款数量', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								if (!value || value <= 0) {
									callback(new Error('请输入大于零的整数'));
								} else if (!Number.isInteger(Number(value))) {
									callback(new Error('请输入整数'));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					]
				},
	
				tableData: [],
				selectedRowKeys: [],
				tableColumns: [
					{
						title: '票号',
						dataIndex: 'ticketNumber',
						key: 'ticketNumber',
						align: 'center'
					},
					{
						title: '产品名称',
						dataIndex: 'productName',
						key: 'productName',
						align: 'center'
					},
					{
						title: '人群种类',
						dataIndex: 'crowdtypeName',
						key: 'crowdtypeName',
						align: 'center',
					},
					{
						title: '业务类型',
						dataIndex: 'businesstypeName',
						key: 'businesstypeName',
						align: 'center',
					},
					{
						title: '数量',
						dataIndex: 'quantity',
						key: 'quantity',
						align: 'center',
					},
					{
						title: '金额',
						key: 'totalPrice',
						align: 'center',
						scopedSlots: {
							customRender: 'totalPrice'
						}
					},
					{
						title: '总数|检票数|退票数',
						key: 'ordersQuantity',
						align: 'center',
						scopedSlots: {
							customRender: 'ordersQuantity'
						}
					},
					{
						title: '下单时间',
						key: 'createTime',
						align: 'center',
						scopedSlots: {
							customRender: 'createTime'
						}
					},
					{
						title: '操作',
						key: 'operation',
						align: 'center',
						scopedSlots: {
							customRender: 'operation'
						}
					}

				],
				tableLoading: false,
				//搜索+表格-end
		
			};
		},
		methods: {
			async apiOrdersQueryByOrderNumber(){
				const{
					data:res
				} = await this.$http.post(this.navigation.apiOrdersQueryByOrderNumber, {ordersNumber: this.ordersNumber});
				if(res.code == 200){
					console.log(res.data)
					this.orderInfo = res.data
				}else{
					this.$message.error(res.msg)
				}

			},
			async apiOrderdetailsQueryAll() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOrderdetailsQueryAll, {ordersNumber: this.ordersNumber});
				if (res.code == 200) {
					this.tableData = res.data
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			routerBack() {
				this.$router.push('/TicktingFlow')
			},
			// 强制退款
			handleForceRefund(operation) {
				if(operation.checkedQuantity <= 0){
					this.$message.error('该订单未检票');
					return;
				}
				// if(operation.quantity<=operation.refundQuantity){
				// 	this.$message.error('该订单已退款');
				// 	return;
				// }
				this.refundForm.refundAmount = 0 
				this.refundForm.orderdetailsId = operation.orderdetailsId
				this.orderdetails = operation
				this.refundForm.type = 2
				this.modalTitle = '订单强制退款'
				this.visible = true
			},
			// 退款
			handleRefund(operation) {
				if(operation.quantity - operation.checkedQuantity - operation.refundQuantity <= 0){
					this.$message.error('该订单已退款');
					return;
				}
				this.refundForm.refundAmount = 0 
				this.refundForm.orderdetailsId = operation.orderdetailsId
				this.orderdetails = operation
				this.refundForm.type = 1
				this.modalTitle = '订单退款'
				this.visible = true
			},
			// 提交退款
			async submitRefund() {
				if(!this.refundForm.refundAmount || this.refundForm.refundAmount <= 0 || !Number.isInteger(Number(this.refundForm.refundAmount))){
					this.$message.error('请输入大于零的整数');
					return;
				}
				const{
					data:res
				} = await this.$http.post(this.navigation.apiOrderdetailsRefund, this.refundForm);
				if(res.code == 200){
					this.$message.success('订单退款成功');
					this.visible = false;
					this.apiOrderdetailsQueryAll()
				}else{
					this.$message.error(res.msg)
				}
				this.visible = false;
			},
			// 批量退款
			handleBatchRefund() {
				if (this.selectedRowKeys.length === 0) {
					this.$message.warning('请选择要退款的票号');
					return;
				}
				// 获取选中的行数据
				const selectedRows = this.tableData.filter(item => 
					this.selectedRowKeys.includes(item.orderdetailsId)
				);
				// 检查是否有订单已完全退款
				let refundIds = []
				let noRefundIds = []
				selectedRows.forEach(item => {
					if (item.quantity - item.checkedQuantity - item.refundQuantity > 0) {
						return refundIds.push(item.orderdetailsId);
					}else{
						noRefundIds.push(item);
					}
				});
				if(noRefundIds.length > 0){
					this.$message.warning("该票号（"+noRefundIds[0].ticketNumber+"）无法退款");
					return;
				}
				// 这里可以添加批量退款的API调用
				this.submitBathRefund(refundIds)
			},
			// 提交批量退款
			async submitBathRefund(ids) {
				const{
					data:res
				} = await this.$http.post(this.navigation.apiOrderdetailsBathRefund, {ids: ids});
				if(res.code == 200){
					this.$message.success('订单退款成功');
					this.visible = false;
					this.apiOrderdetailsQueryAll()
				}else{
					this.$message.error(res.msg)
				}
			},

		},
		computed: {
			rowSelection() {
				let that = this;
				return {
					selectedRowKeys: that.selectedRowKeys,
					onChange: (selectedRowKeys, selectedRows) => {
						that.selectedRowKeys = selectedRowKeys;
						console.log('Selected rows:', selectedRows);
					},
				};
			},
		},
		created() {
			this.apiOrderdetailsQueryAll()
			this.apiOrdersQueryByOrderNumber()
		}
	};
</script>

<style scoped>
	.qa-card-title{
		position: relative;
		height: 50px;
		line-height: 50px;
	}
	.qa-btn-right{
		position: absolute;
		right: 0;
		top: 0;
		height: 50px;
		line-height: 50px;
	}
	.qa-btn{
		margin:0 5px;
	}
	

</style>
